<template>
  <div :class="getClassName('colors')">
    <ul :class="getClassName('colors__items')" v-if="getColors.length > 0">
      <template v-for="color in getColors">
        <li
          :class="getClassName('colors__item')"
          :key="`${uuid}-${color.id}`"
          v-if="!simulation || (simulation && color.simulation_image)"
        >
          <label
            :class="getClassNameActive('colors__action', color, value.item_color_id)"
            :for="`${uuid}-${color.id}`"
          >
            <v-img
              :src="color.thumbnail"
              :alt="color.name"
              :width="media ? '66' : '78'"
              :height="media ? '66' : '78'"
            />
            <input
              type="radio"
              :id="`${uuid}-${color.id}`"
              :value="color.id"
              v-model="internalValue"
              v-show="false"
            />
          </label>
          <div :class="getClassName('colors__name')" v-if="items.length > 1">{{ color.item.name }}</div>
          <div :class="getClassName('colors__name')">{{ color.name }}</div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';

import getClassName from '../../_mixins/getClassName';

export default {
  mixins: [getClassName],
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    value: {
      type: Object,
      required: true,
      default: () => {},
    },
    media: {
      type: Boolean,
      required: true,
      default: false,
    },
    simulation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    const uuid = uuidv4();
    return {
      uuid: uuid,
    };
  },
  computed: {
    internalValue: {
      get() {
        return this.value.item_color_id;
      },
      set(newValue) {
        // カラーIDが変更されていない場合は何もしない
        if (this.value.item_color_id === newValue) return;

        let option_id = null;
        if(this.getOption(newValue) !== undefined){
          // 遷移元のカラーでサイズにチェックが入っていたなら、オプションIDを取得
          // なかった場合はnullをセット（遷移元で全サイズが在庫なしだった場合など）
          option_id = this.getOption(newValue).id;
        }

        // カラーIDを変更してイベントを発火
        this.$emit('input', {
          ...this.value,
          item_color_id: newValue,
          ...(this.simulation ? {} : { item_option_id: option_id }),
        });
      },
    },
    getColors() {
      return this.items.flatMap((item) => item.colors.map((color) => ({ ...color, item: item })));
    },
  },
  methods: {
    getOption(colorId) {
      const [option] = this.items
        .flatMap((item) => item.options)
        .filter(
          (option) =>
            option.item_color_id === parseInt(colorId) &&
            option.item_size_id === parseInt(this.value.item_size_id)
        );
      return option;
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../../_sass/variables';

.colors {
  &__items {
    width: calc(100% + 26px);
    margin: -13px;
    display: flex;
    flex-flow: row wrap;
    &--sp {
      width: calc(100% + 20px);
      margin: -10px;
    }
  }
  &__item {
    width: 78px;
    margin: 13px;
    &--sp {
      width: 66px;
      margin: 10px;
    }
  }
  &__action {
    display: block;
    transition: box-shadow 0.2s ease 0s;
    cursor: pointer;
    &--active {
      box-shadow: 0px 0px 0px 4px $color__active;
    }
    &--sp.colors__action--active {
      box-shadow: 0px 0px 0px 3px $color__active;
    }
  }
  &__name {
    text-align: center;
    // white-space: nowrap;
    margin: 5px -4px 0px;
    line-height: 17px;
    padding-top: 3px;
    &--sp {
      font-size: 0.8rem;
    }
  }
  &__name + &__name {
    margin-top: 0;
  }
}
</style>
